export default function initListeLogos() {
    const $containers = document.querySelectorAll<HTMLElement>('.block-liste-logos');
    $containers.forEach($container => {
        new ListeLogos($container);
    });
}

class ListeLogos {
    $el: HTMLElement;
    $logosList: HTMLElement | null;
    $scrollContainer: HTMLElement | null;

    private _resizeTimer: ReturnType<typeof setTimeout> | null = null;
    private _boundOnResize: () => void;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$logosList = $el?.querySelector('.logos-wrapper');
        this.$scrollContainer = $el?.querySelector('.js-scroll-container');

        this._boundOnResize = this.onResize.bind(this);

        if (document.readyState === 'complete') {
            this.init();
        } else {
            window.addEventListener('load', () => this.init());
        }

        window.addEventListener('resize', this._boundOnResize);
    }

    private reset() {
        if (!this.$scrollContainer || !this.$logosList) return;

        // Supprimer tous les clones (garder uniquement le premier .logos-wrapper)
        this.$scrollContainer.querySelectorAll('.logos-wrapper:not(:first-child)').forEach($clone => {
            $clone.remove();
        });

        // Retirer la classe d'animation sur l'original
        this.$logosList.classList.remove('logos-wrapper-slide');
    }

    init() {
        if (!this.$scrollContainer || !this.$logosList) return;

        const containerWidth = this.$el.clientWidth;
        const logoWidth = this.$logosList.clientWidth;

        if (!logoWidth) return;

        if (logoWidth < containerWidth) return;

        const logosNeeded = Math.ceil(containerWidth / logoWidth) + 1;

        for (let i = 0; i < logosNeeded; i++) {
            const copy = this.$logosList.cloneNode(true);
            this.$scrollContainer.appendChild(copy);
        }

        this.$el.querySelectorAll('.logos-wrapper').forEach($elem => {
            $elem.classList.add('logos-wrapper-slide');
        });
    }

    private onResize() {
        if (this._resizeTimer) clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => {
            this.reset();
            this.init();
        }, 200);
    }
}
